import { css } from "styled-components";
import { pxToRem } from "@input-output-hk/px-to-rem";

export const shadowFilter = css`
  filter: drop-shadow(0 ${pxToRem(4)} ${pxToRem(4)} rgba(0, 0, 0, 0.25));
`;
